import { ColorCode } from '@/modules/core/enums/color-code.enum.ts';
import type { DocumentColorState } from '@/modules/document/types/document-color.type.ts';

export const DOCUMENT_HEADER_COLOR_KEY = 'document-color';

export const DEFAULT_DOCUMENT_COLOR_STATE: DocumentColorState = {
  color: null,
  isLocked: false,
  isLockedByDocument: false,
  lockSource: null,
};

export const DOCUMENT_COLOR_OPTIONS = [
  { code: ColorCode.None, name: 'none' },
  { code: ColorCode.Gray, name: 'gray' },
  { code: ColorCode.Green, name: 'green' },
  { code: ColorCode.Red, name: 'red' },
  { code: ColorCode.Blue, name: 'blue' },
  { code: ColorCode.Yellow, name: 'yellow' },
  { code: ColorCode.Purple, name: 'purple' },
] as const;
